import React from "react";
import { motion } from "framer-motion";
import { IMAGES, Reveal, Eyebrow, EASE } from "./shared";

const MARQUEE = ["Regional Expertise", "Disciplined Execution", "Long-Term Partnerships", "Enduring Value", "Beyond Borders"];

export const Vision = () => {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative py-28 lg:py-40 overflow-hidden"
      style={{ backgroundColor: "#FAF9F7" }}
    >
      {/* Editorial marquee */}
      <div className="pt-12 lg:pt-16 mb-24 select-none" aria-hidden="true">
        <div className="marquee-track">
          {[0, 1].map((rep) => (
            <div key={rep} className="flex items-center">
              {MARQUEE.map((m, i) => (
                <span key={`${rep}-${i}`} className="flex items-center">
                  <span className="text-4xl sm:text-6xl font-bold px-8" style={{ color: i % 2 === 0 ? "#F2F1EF" : "#2B2B2B", WebkitTextStroke: i % 2 === 0 ? "1px #D8D8D8" : "none" }}>
                    {m}
                  </span>
                  <span className="text-4xl sm:text-6xl" style={{ color: "#F5821F" }}>&bull;</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Image left */}
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Reveal className="relative overflow-hidden rounded-sm" style={{ aspectRatio: "16/11" }}>
            <motion.img
              src={IMAGES.vision}
              alt="Green field near a concrete bridge under blue sky"
              className="w-full h-full object-cover"
              initial={{ scale: 1.15 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: EASE }}
            />
          </Reveal>
        </div>

        {/* Text */}
        <div className="lg:col-span-6 order-1 lg:order-2 lg:pl-8">
          <Reveal><Eyebrow>Our Vision</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-bold leading-[1.08] text-3xl sm:text-4xl lg:text-5xl" style={{ color: "#2B2B2B" }}>
              Growing <span style={{ color: "#3B2C82" }}>Beyond Borders</span>
            </h2>
          </Reveal>
          <div className="mt-8 space-y-5 max-w-xl text-base lg:text-lg leading-relaxed">
            <Reveal delay={0.1} as="p" style={{ color: "#2B2B2B" }}>
              Fortim’s story begins in DNHDD, but it doesn’t end here.
            </Reveal>
            <Reveal delay={0.15} as="p" style={{ color: "#8C8C8C" }}>
              Our vision is to build a diversified group of businesses that combine regional
              expertise with disciplined execution to create enduring value across industries and
              markets.
            </Reveal>
            <Reveal delay={0.2} as="p" style={{ color: "#8C8C8C" }}>
              As new opportunities emerge, we’ll continue building ventures that remain true to the
              principles on which Fortim was founded.
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
